import React, { useEffect, useRef, useState } from 'react';
import Button from "@/components/ui/Button";
import LinkLikeButton from "@/components/ui/LinkLikeButton";
import Link from 'next/link'
import useSectionsStore from '@/stores/SectionsStore';
import gsap from 'gsap';
import { usePathname } from 'next/navigation';
import useFormStore from "../../stores/FormStore.jsx";
import useBgColorStore from "../../stores/bgColorStore.jsx";
import { useRouter } from 'next/router.js';


const Header = ({headerData}) => {

    const [mobileMenuOpen, setMobileMenuOpen] = useState(false)
    const [servicesOpen, setServicesOpen] = useState(false)
    const [servicesOpenMobile, setServicesOpenMobile] = useState(true)
    const { currentColorClass } = useBgColorStore();
    const {homeHeroSection} = useSectionsStore();
    const logo = useRef(null)
    const navList = useRef(null)
    const logoDash = useRef(null)
    const [isFirstLoad, setIsFirstLoad] = useState(false);
    const pathname = usePathname();

    const router = useRouter()
    const { locale } = router

    const contacts = headerData?.menu?.find(
        item => item.text === 'Contacts'
    );

  const {
        openPopUp, setOpenPopUp
    } = useFormStore();


  useEffect(() => {
      if (pathname !== '/') {
        setIsFirstLoad(true);
      }
  }, [pathname]);



useEffect(() => {

  setMobileMenuOpen(false)
  setServicesOpen(false)

  if (!homeHeroSection?.current || pathname !== "/") return;

  const animations = [];

  const mm = gsap.matchMedia();

  mm.add("(min-width: 1792px)", () => {
    const anim1 = gsap.fromTo(
      logo.current,
      { height: "21.9rem", top: '5rem' },
      {
        height: "3.4rem",
        top: 0,
        ease: "none",
        scrollTrigger: {
          trigger: homeHeroSection.current,
          start: "top top",
          end: "25% top",
          scrub: 0.8,
        },
      }
    );

    const anim2 = gsap.fromTo(
      navList.current,
      { paddingTop: "32.8rem" },
      {
        paddingTop: "0",
        ease: "none",
        scrollTrigger: {
          trigger: homeHeroSection.current,
          start: "top top",
          end: "25% top",
          scrub: 0.8,
        },
      }
    );

    animations.push(anim1, anim2);
  });



    mm.add("(min-width: 1280px) and (max-width: 1791px)", () => {
    const anim3 = gsap.fromTo(
      logo.current,
      { height: "16.9rem", top: '5rem' },
      {
        height: "3.4rem",
         top: '0rem',
        ease: "none",
        scrollTrigger: {
          trigger: homeHeroSection.current,
          start: "top top",
          end: "25% top",
          scrub: 0.8,
        },
      }
    );

    const anim4 = gsap.fromTo(
      navList.current,
      { paddingTop: "25.8rem" },
      {
        paddingTop: "0",
        ease: "none",
        scrollTrigger: {
          trigger: homeHeroSection.current,
          start: "top top",
          end: "25% top",
          scrub: 0.8,
        },
      }
    );
    animations.push(anim3, anim4);
  });


  if (logoDash.current) {
    const anim9 = gsap.fromTo(logoDash.current, {opacity: 1}, {
      opacity: 0,
      ease: "none",
      scrollTrigger: {
          trigger: homeHeroSection.current,
          start: "top top",
          end: "10% top",
       scrub: 0.8,
      },
    });
    animations.push(anim9);
  }


  return () => {
    animations.forEach((anim) => {
      anim.kill();
      if (anim.scrollTrigger) anim.scrollTrigger.kill();
    });
    mm.revert();
  };
}, [homeHeroSection?.current, pathname]);


  const getLinkClasses = (href) => {
    const base = "whitespace-nowrap hover:text-dusty-pink duration-300 relative transition-colors text-menu";
    const active = "italic !text-dusty-blue-light before:content-[''] before:absolute before:-left-[1rem] before:top-1/2 before:-translate-y-1/2 before:w-[0.4rem] before:h-[0.4rem] lg:before:bg-dusty-blue-light";
    return pathname.includes(href)   ? `${base} ${active}` : base;
  };

    const getLinkClassesMobile = (href) => {
    const base = "whitespace-nowrap font-medium font-inter text-[2.2rem] text-dark-blue md:text-[2.8rem] hover:text-dusty-pink duration-300 relative transition-colors text-menu";
    const active = "italic !text-dusty-blue-light before:content-[''] before:absolute before:-left-[1rem] before:top-1/2 before:-translate-y-1/2 before:w-[0.4rem] before:h-[0.4rem] lg:before:bg-dusty-blue-light";
    return pathname.includes(href) ? `${base} ${active}` : base;
  };

  return (
    <>
    <div onClick={()=> {setServicesOpen(false)}} className={`${servicesOpen ? 'lg:pointer-events-auto lg:opacity-40' : 'pointer-events-none opacity-0'} transition-opacity duration-300 pointer-events-none fixed inset-0 z-30 bg-dark-blue`}></div>

    <header className={` text-dark-blue z-40 w-full top-0 left-0 fixed container-padding  py-[1.4rem] md:py-[1.6rem] lg:py-[1.5rem] xl:py-[2rem] transition-colors duration-500 ${currentColorClass}`}>
      <div className="absolute container-max top-0 left-1/2 -translate-x-1/2 w-full items-start  flex justify-end   py-[1.4rem] md:py-[1.6rem] container-padding  lg:py-[1.5rem] xl:py-[2rem] ">
        <div className="flex items-center absolute container-padding  left-0 z-20">
          <div ref={logo} className={`${pathname === "/" && !isFirstLoad ? 'lg:h-[16.9rem] lg:top-[5rem] xl:h-[21.9rem]' : 'h-[2.8rem] md:h-[3.4rem]'}  relative flex items-center justify-center`}>
            <Link aria-label='Главная' scroll={false} href="/" className="h-full flex items-center">
                {/* <img fetchPriority="low" className="h-full" src="/logo.svg" alt="" /> */}

                <svg width="130" className='h-full w-auto' height="34" viewBox="0 0 130 34" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8.24812 26.452H1.96384V23.0879H8.02612C9.96149 23.0879 11.5724 22.7293 12.8589 22.0121C14.1453 21.2834 15.1073 20.219 15.7449 18.8187C16.3824 17.407 16.7012 15.6993 16.7012 13.6956C16.7012 11.7033 16.3824 10.0127 15.7449 8.62381C15.1187 7.23489 14.1795 6.18182 12.9272 5.46459C11.6749 4.73598 10.1209 4.37167 8.26519 4.37167H1.82722V1.00753H8.50427C10.9975 1.00753 13.1378 1.51415 14.9252 2.52737C16.7125 3.5406 18.0844 4.99782 19.0407 6.89905C19.997 8.78888 20.4751 11.0544 20.4751 13.6956C20.4751 16.3482 19.9913 18.6251 19.0236 20.5264C18.0673 22.4276 16.6784 23.8905 14.8569 24.9151C13.0353 25.9397 10.8324 26.452 8.24812 26.452ZM3.84229 1.00753V26.452H0V1.00753H3.84229Z" fill="#544B71"/>
                <path d="M31.7117 26.8448C29.8446 26.8448 28.228 26.4407 26.8619 25.6323C25.4957 24.824 24.4427 23.6856 23.7027 22.217C22.9741 20.737 22.6097 19.0122 22.6097 17.0427C22.6097 15.0845 22.9684 13.3598 23.6856 11.8684C24.4142 10.377 25.4331 9.21581 26.7423 8.38473C28.063 7.54227 29.6113 7.12105 31.3872 7.12105C32.4688 7.12105 33.5162 7.29751 34.5294 7.65043C35.5426 8.00335 36.4534 8.56119 37.2617 9.32396C38.07 10.0867 38.7075 11.0772 39.1743 12.2953C39.6524 13.5135 39.8915 14.9821 39.8915 16.7012V18.0331H24.7102V15.2496H37.9789L36.2541 16.1718C36.2541 14.9992 36.072 13.9632 35.7077 13.0638C35.3434 12.1644 34.7969 11.4643 34.0683 10.9633C33.3511 10.451 32.4574 10.1949 31.3872 10.1949C30.3171 10.1949 29.4006 10.451 28.6379 10.9633C27.8865 11.4756 27.3116 12.153 26.9131 12.9955C26.5147 13.8379 26.3154 14.7601 26.3154 15.7619V17.6575C26.3154 18.9667 26.5431 20.0767 26.9985 20.9874C27.4539 21.8982 28.0857 22.5927 28.894 23.0708C29.7137 23.549 30.6643 23.788 31.7459 23.788C32.4517 23.788 33.0892 23.6856 33.6585 23.4807C34.2391 23.2757 34.74 22.9684 35.1612 22.5585C35.5825 22.1487 35.9012 21.6421 36.1175 21.0387L39.6354 21.7047C39.3507 22.7293 38.8498 23.6287 38.1326 24.4028C37.4154 25.177 36.5103 25.7803 35.4174 26.213C34.3358 26.6342 33.1006 26.8448 31.7117 26.8448Z" fill="#544B71"/>
                <path d="M56.7634 12.0392L53.3993 12.6198C53.183 11.9823 52.7788 11.3959 52.1868 10.8609C51.6062 10.3258 50.7353 10.0583 49.5741 10.0583C48.5267 10.0583 47.6501 10.2973 46.9442 10.7755C46.2498 11.2423 45.9026 11.8399 45.9026 12.5686C45.9026 13.2061 46.1359 13.7241 46.6027 14.1226C47.0809 14.521 47.8379 14.8398 48.8739 15.0789L51.9307 15.7619C53.6725 16.1604 54.9761 16.7865 55.8413 17.6404C56.7065 18.4942 57.1391 19.5871 57.1391 20.9191C57.1391 22.069 56.809 23.0936 56.1487 23.993C55.4884 24.881 54.5719 25.5811 53.3993 26.0934C52.2267 26.5943 50.8719 26.8448 49.335 26.8448C47.1947 26.8448 45.4529 26.3837 44.1095 25.4616C42.7661 24.5394 41.9407 23.2416 41.6333 21.5681L45.2024 21.0216C45.4301 21.9551 45.8912 22.661 46.5856 23.1391C47.2915 23.6173 48.2022 23.8564 49.3179 23.8564C50.5247 23.8564 51.4924 23.6002 52.221 23.0879C52.961 22.5756 53.331 21.9551 53.331 21.2265C53.331 20.0198 52.4316 19.2058 50.6328 18.7845L47.4053 18.0673C45.6179 17.6575 44.2973 17.0142 43.4435 16.1376C42.601 15.2496 42.1798 14.1339 42.1798 12.7906C42.1798 11.6635 42.4929 10.673 43.119 9.81919C43.7566 8.96534 44.6275 8.30504 45.7318 7.83827C46.8475 7.36012 48.1169 7.12105 49.5399 7.12105C51.6119 7.12105 53.2342 7.57074 54.4068 8.47012C55.5908 9.3695 56.3764 10.5592 56.7634 12.0392Z" fill="#544B71"/>
                <path d="M59.7348 26.452V7.36012H63.4234V26.452H59.7348ZM61.5962 4.4229C60.9473 4.4229 60.3951 4.2066 59.9397 3.77398C59.4843 3.34137 59.2567 2.82337 59.2567 2.21999C59.2567 1.60522 59.4843 1.08153 59.9397 0.64892C60.3951 0.216307 60.9473 0 61.5962 0C62.2337 0 62.7802 0.216307 63.2356 0.64892C63.7023 1.08153 63.9357 1.60522 63.9357 2.21999C63.9357 2.82337 63.7023 3.34137 63.2356 3.77398C62.7802 4.2066 62.2337 4.4229 61.5962 4.4229Z" fill="#544B71"/>
                <path d="M74.9332 34C72.6563 34 70.8632 33.5731 69.554 32.7192C68.2448 31.8654 67.3397 30.8522 66.8388 29.6796L70.0151 28.3646C70.2428 28.7289 70.5444 29.116 70.9201 29.5259C71.3072 29.9357 71.8252 30.2829 72.4741 30.5676C73.1231 30.8522 73.9598 30.9945 74.9844 30.9945C76.3847 30.9945 77.546 30.6529 78.4681 29.9699C79.3903 29.2982 79.8513 28.2166 79.8513 26.7253V22.9854H79.5952C79.3903 23.3839 79.0772 23.8336 78.656 24.3345C78.2347 24.824 77.6598 25.251 76.9312 25.6153C76.2026 25.9796 75.252 26.1617 74.0794 26.1617C72.5766 26.1617 71.2218 25.8088 70.0151 25.103C68.8197 24.3857 67.8634 23.3384 67.1462 21.9608C66.4403 20.5719 66.0874 18.8642 66.0874 16.8378C66.0874 14.8113 66.4346 13.0752 67.1291 11.6293C67.8349 10.1721 68.7912 9.05642 69.998 8.28227C71.2048 7.50812 72.5766 7.12105 74.1135 7.12105C75.2975 7.12105 76.2538 7.32027 76.9824 7.71873C77.7224 8.10581 78.2973 8.56119 78.7072 9.08488C79.117 9.60857 79.4358 10.0696 79.6635 10.4681H79.9367V7.36012H83.5399V26.879C83.5399 28.5183 83.1585 29.8617 82.3958 30.9091C81.6444 31.9565 80.6198 32.7306 79.322 33.2315C78.0241 33.7439 76.5612 34 74.9332 34ZM74.899 23.0708C76.5043 23.0708 77.7338 22.5187 78.5876 21.4144C79.4529 20.2987 79.8855 18.7561 79.8855 16.7865C79.8855 15.5001 79.6976 14.373 79.322 13.4053C78.9463 12.4263 78.3884 11.6635 77.6484 11.117C76.9084 10.5592 75.992 10.2803 74.899 10.2803C73.7834 10.2803 72.8498 10.5706 72.0984 11.1512C71.3585 11.7204 70.8006 12.5003 70.4249 13.4907C70.0492 14.4698 69.8614 15.5684 69.8614 16.7865C69.8614 18.0275 70.0492 19.1261 70.4249 20.0824C70.8006 21.0273 71.3641 21.7616 72.1155 22.2853C72.8783 22.809 73.8061 23.0708 74.899 23.0708Z" fill="#544B71"/>
                <path d="M90.7805 15.1301V26.452H87.0919V7.36012H90.678V10.5023H90.9342C91.3668 9.46626 92.0442 8.64658 92.9663 8.04319C93.8885 7.42843 95.0725 7.12105 96.5183 7.12105C97.8162 7.12105 98.9489 7.39427 99.9166 7.94073C100.896 8.47581 101.653 9.27842 102.188 10.3486C102.734 11.4187 103.008 12.745 103.008 14.3275V26.452H99.3189V14.7715C99.3189 13.3939 98.9546 12.3124 98.226 11.5269C97.4974 10.73 96.507 10.3315 95.2546 10.3315C94.4008 10.3315 93.6323 10.525 92.9493 10.9121C92.2776 11.2878 91.7482 11.8286 91.3611 12.5344C90.9741 13.2402 90.7805 14.1055 90.7805 15.1301Z" fill="#544B71"/>
                <path d="M106.56 26.452V7.36012H110.248V26.452H106.56ZM108.421 4.4229C107.772 4.4229 107.22 4.2066 106.764 3.77398C106.309 3.34137 106.081 2.82337 106.081 2.21999C106.081 1.60522 106.309 1.08153 106.764 0.64892C107.22 0.216307 107.772 0 108.421 0C109.058 0 109.605 0.216307 110.06 0.64892C110.527 1.08153 110.76 1.60522 110.76 2.21999C110.76 2.82337 110.527 3.34137 110.06 3.77398C109.605 4.2066 109.058 4.4229 108.421 4.4229Z" fill="#544B71"/>
                <path d="M121.809 26.8448C119.976 26.8448 118.394 26.4236 117.062 25.5811C115.73 24.7387 114.705 23.5774 113.988 22.0974C113.271 20.6174 112.912 18.9211 112.912 17.0085C112.912 15.0618 113.276 13.3484 114.005 11.8684C114.745 10.377 115.775 9.21581 117.096 8.38473C118.428 7.54227 119.988 7.12105 121.775 7.12105C123.232 7.12105 124.524 7.38858 125.651 7.92366C126.79 8.44735 127.706 9.19304 128.401 10.1607C129.107 11.1284 129.522 12.2555 129.647 13.5419H126.027C125.902 12.9386 125.657 12.3864 125.293 11.8855C124.94 11.3846 124.473 10.9861 123.893 10.6901C123.312 10.3941 122.623 10.2461 121.826 10.2461C120.79 10.2461 119.885 10.5193 119.111 11.0658C118.348 11.6009 117.751 12.3693 117.318 13.3712C116.885 14.373 116.669 15.557 116.669 16.9232C116.669 18.3007 116.88 19.5018 117.301 20.5264C117.722 21.551 118.32 22.3422 119.094 22.9001C119.879 23.4465 120.79 23.7197 121.826 23.7197C122.896 23.7197 123.807 23.4237 124.559 22.8317C125.321 22.2397 125.811 21.4314 126.027 20.4068H129.647C129.522 21.6477 129.124 22.7521 128.452 23.7197C127.78 24.6874 126.881 25.4502 125.754 26.008C124.627 26.5659 123.312 26.8448 121.809 26.8448Z" fill="#544B71"/>
                </svg>

            </Link>
          {pathname === "/" ? <div ref={logoDash} className='absolute hidden lg:block logo-dash top-1/2 -translate-y-1/2 left-[106.5%]  opacity-100 h-[6.5%]  aspect-[11] bg-dusty-blue'></div> : null}
          </div>

          <div className="h-[2.8rem] md:h-[4.4rem]"></div>
        </div>

        <div className="flex  justify-end  items-center lg:col-start-11 lg:col-span-2 md:col-start-5 ">
            {locale === 'en' ? (
                contacts && (
                    <LinkLikeButton className='w-full' isFullSized={false} href={contacts.link}>
                        {headerData.btn_text}
                        <svg
                            className="hidden md:inline-block"
                            width="13"
                            height="14"
                            viewBox="0 0 13 14"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path d="M0 7H12M12 7L6 1M12 7L6 13" stroke="CurrentColor"/>
                        </svg>
                    </LinkLikeButton>
                )
            ) : (
                <Button  onClick={() => setOpenPopUp(true)} isFullSized={false}>
                    {headerData.btn_text}
                    <svg
                        className="hidden md:inline-block"
                        width="13"
                        height="14"
                        viewBox="0 0 13 14"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path d="M0 7H12M12 7L6 1M12 7L6 13" stroke="CurrentColor" />
                    </svg>
                </Button>
            )}

          <button type="button" aria-label="Открыть меню" className='cursor-pointer text-dark-blue' onClick={(()=> {setMobileMenuOpen(true)})}>
            <svg className="ml-[0.8rem] md:ml-[1.6rem] h-[3.2rem] lg:hidden" width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M5 13H27" stroke="CurrentColor"/>
            <path d="M5 19H27" stroke="CurrentColor"/>
            </svg>
          </button>
        </div>

        <div className={`${mobileMenuOpen ? 'flex flex-col lg:hidden' : 'hidden'} top-0  absolute min-h-[150vh] left-0 w-full `}>
          <div className={`relative w-full z-10 container-padding md:justify-center pt-[8rem] h-[60rem] md:h-[100svh] pb-[3.2rem] gap-[3.2rem] flex flex-col transition-colors duration-500 ${currentColorClass}`}>
            <button type='button' aria-label="Закрыть меню" className=' absolute cursor-pointer right-[2.6rem] md:right-[3rem] md:top-[2.8rem] top-[2.1rem]' onClick={(()=> {setMobileMenuOpen(false)})}>
              <svg className='h-[1.8rem]'  height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M7 7L1 1M7 7L1 13M7 7L13 1M7 7L13 13" stroke="CurrentColor"/>
              </svg>
            </button>

        <div className="pointer-events-auto relative justify-start items-start col-start-4 flex  flex-col">
          <button onClick={(()=> {setServicesOpenMobile((prev)=> !prev)})} className={`${getLinkClasses('/uslugi/')} whitespace-nowrap font-medium font-inter hover:text-dusty-pink duration-300 transition-colors text-[2.2rem] md:text-[2.8rem] text-dark-blue  cursor-pointer flex items-center`} >
            {headerData.menu[0].text}
            <svg
                className={`${servicesOpenMobile ? "rotate-180" : ""} ml-[1.2rem]`}
                width="15"
                height="8"
                viewBox="0 0 15 8"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M1 1.5L7.5 6.5L14 1.5"
                  stroke="CurrentColor"
                  strokeWidth="1.3"
                />
              </svg>
          </button>

          <div className={`${servicesOpenMobile ? 'max-h-[50rem]' : 'max-h-0'} overflow-hidden    `}>
            <div className='pt-[2.4rem] md:gap-[3rem] md:pt-[3rem] gap-[2.4rem]  flex flex-col'>
              <Link scroll={false} className={`md:text-[2rem] ${getLinkClasses('/uslugi/ofisy-i-delovye-prostranstva/')}`} href="/uslugi/ofisy-i-delovye-prostranstva/">
                  {headerData.menu[0].children[0].text}
              </Link>
              <Link scroll={false} className={`md:text-[2rem] ${ getLinkClasses('/uslugi/uchebnye-czentry-i-kampusy/')}`} href="/uslugi/uchebnye-czentry-i-kampusy/">
                  {headerData.menu[0].children[1].text}
              </Link>
              <Link scroll={false} className={`md:text-[2rem] ${ getLinkClasses('/uslugi/apart-oteli-i-gostinichnye-proekty/')}`} href="/uslugi/apart-oteli-i-gostinichnye-proekty/">
                {headerData.menu[0].children[2].text}
              </Link>
              <Link scroll={false} className={`md:text-[2rem] ${getLinkClasses('/uslugi/mnogofunczionalnye-prostranstva/')}`} href="/uslugi/mnogofunczionalnye-prostranstva/">
                {headerData.menu[0].children[3].text}
              </Link>
            </div>

          </div>
        </div>


          <Link scroll={false} className={getLinkClassesMobile('/proekty/')} href="/proekty/">
            {headerData.menu[1].text}
          </Link>

          <Link scroll={false} className={getLinkClassesMobile('/o-nas/')} href="/o-nas/">
            {headerData.menu[2].text}
          </Link>


          <a style={{display: locale === 'ru' ? '' : 'none'}} className={getLinkClassesMobile('/blog/')} href={headerData.menu[3].link}>
            {headerData.menu[3].text}
          </a>

          {headerData.menu?.[4] ? <a  className={getLinkClassesMobile('/kontakty/')} href={headerData.menu?.[4]?.link}>
            {headerData.menu?.[4]?.text}
          </a> : null}


              <div className='w-full left-0 container-padding absolute bottom-[3rem]'>
                  {locale === 'en' ? (
                      contacts && (
                          <LinkLikeButton className='w-full' isFullSized={true} href={contacts.link}>
                              {headerData.btn_text}
                              <svg className="inline-block" width="13" height="14" viewBox="0 0 13 14" fill="none"
                                   xmlns="http://www.w3.org/2000/svg">
                                  <path d="M0 7H12M12 7L6 1M12 7L6 13" stroke="CurrentColor"/>
                              </svg>
                          </LinkLikeButton>
                      )
                  ) : (
                      <Button onClick={() => setOpenPopUp(true)} className='w-full' isFullSized={true}>
                          {headerData.btn_text}
                          <svg className="inline-block" width="13" height="14" viewBox="0 0 13 14" fill="none"
                               xmlns="http://www.w3.org/2000/svg">
                              <path d="M0 7H12M12 7L6 1M12 7L6 13" stroke="CurrentColor"/>
                          </svg>
                      </Button>
                  )}
              </div>
          </div>
          <div className='absolute inset-0 bg-dark-blue opacity-40'></div>
        </div>

      </div>


      <nav ref={navList} className={`${pathname === '/' && !isFirstLoad ? 'lg:pt-[25.8rem] xl:pt-[32.8rem]' : ''} container-grid container-max pointer-events-none relative z-10`}>
        <div className="pointer-events-auto relative justify-end hidden items-center col-start-4 lg:flex">
          <button onClick={(()=> {setServicesOpen((prev)=> !prev)})} className={`${getLinkClasses('/uslugi/')} whitespace-nowrap hover:text-dusty-pink duration-300 transition-colors text-menu  cursor-pointer flex items-center`} >
            {headerData.menu[0].text}
            <svg
                className={`${servicesOpen ? "rotate-180" : ""} transition-transform duration-300 ml-[1.2rem]`}
                width="15"
                height="8"
                viewBox="0 0 15 8"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M1 1.5L7.5 6.5L14 1.5"
                  stroke="CurrentColor"
                  strokeWidth="1.3"
                />
              </svg>
          </button>

          <div className={`${servicesOpen ? 'opacity-100 pointer-events-auto' : 'opacity-0 pointer-events-none'}   flex top-[100%] absolute z-10 left-0 ${currentColorClass} transition-all duration-500 flex flex-col gap-[1.6rem] px-[4rem] pb-[2.4rem] pt-[3rem]`}>
              <Link scroll={false} className={getLinkClasses('/uslugi/ofisy-i-delovye-prostranstva/')} href="/uslugi/ofisy-i-delovye-prostranstva/">
                {headerData.menu[0].children[0].text}
              </Link>
              <Link scroll={false} className={getLinkClasses('/uslugi/uchebnye-czentry-i-kampusy/')} href="/uslugi/uchebnye-czentry-i-kampusy/">
                {headerData.menu[0].children[1].text}
              </Link>
              <Link scroll={false} className={getLinkClasses('/uslugi/apart-oteli-i-gostinichnye-proekty/')} href="/uslugi/apart-oteli-i-gostinichnye-proekty/">
                {headerData.menu[0].children[2].text}
              </Link>
              <Link scroll={false} className={getLinkClasses('/uslugi/mnogofunczionalnye-prostranstva/')} href="/uslugi/mnogofunczionalnye-prostranstva/">
                {headerData.menu[0].children[3].text}
              </Link>
          </div>
        </div>

        <div className="hidden pointer-events-auto items-center col-start-5 lg:flex justify-end ">
          <Link scroll={false} className={getLinkClasses('/proekty/')} href="/proekty/">
            {headerData.menu[1].text}
          </Link>
        </div>

        <div className="hidden pointer-events-auto justify-between items-center col-start-7 lg:flex">
          <Link scroll={false} className={getLinkClasses('/o-nas/')} href="/o-nas/">
            {headerData.menu[2].text}
          </Link>
          <a style={{display: locale === 'ru' ? '' : 'none'}} className={getLinkClasses('/blog/')} href={headerData.menu[3].link}>
            {headerData.menu[3].text}
          </a>
        </div>

        <div className="hidden pointer-events-auto col-start-8 col-span-2 items-center lg:flex justify-end">
          {headerData.menu?.[4] ? <a  className={getLinkClasses('/kontakty/')} href={headerData?.menu[4]?.link}>
            {headerData.menu?.[4]?.text}
          </a> : null}

        </div>

        <div className="h-[2.8rem] md:h-[4.4rem]"></div>
      </nav>
    </header>
    </>
  );
};

export default Header;